export default __webpack_public_path__ + "static/media/Troy.9bfec1f2.jpg";